import { CrudModel } from "../plugins/Cruxtify/CrudModel";

export class ErCrudModel extends CrudModel {}
